module Widgets.Form.Checkbox where

import Common

import Concur.React.DOM as D
import Concur.React.Props as P
import Data.Argonaut as J
import GraphQL.Shape (QueryField(..))
import Widgets.Checkbox (checkbox)
import Widgets.Form.Class (class FormWidget, fieldAccessProps, formWidgetState, fieldId, setFromJson)


newtype Checkbox = Checkbox CheckboxType
derive newtype instance showCheckbox :: Show Checkbox
type CheckboxType =
    { id :: String
    , label :: String
    , cls :: String
    , legacy :: Boolean
    , value :: Boolean
    }

instance checkboxFW :: FormWidget Checkbox where
    getId (Checkbox state) = state.id
    isLeaf _ = true
    asField (Checkbox state) = Just $ QScalar state.id
    fieldPaths fc (Checkbox state) = [ fieldId fc state.id ]

    toWidget fc (Checkbox state) = formWidgetState <$>
        Checkbox <$> state { value = _ } <$> D.div
            [ P.key id, P.className fieldClass' ]
            [ checkbox ([ P._id id ] <> fieldAccessProps fc state.id) state.value
            , D.label
                [ P.htmlFor id, P.className "mx-3"
                , P.dangerouslySetInnerHTML { __html: state.label } ]
                [ ]
            ]
      where
        id = fieldId fc state.id
        fieldClass' = if state.cls == ""
            then "flex col-span-12 items-center"
            else "flex items-center " <> state.cls

    getData _ (Checkbox { legacy: true, value: false }) = J.fromString "NO"
    getData _ (Checkbox { legacy: true, value: true }) = J.fromString "YES"
    getData _ (Checkbox { value }) = J.fromBoolean value

    setData _ st@(Checkbox state) json =
        if J.isBoolean json
            then setBool json
            else setYesNo json
      where
        setYesNo = setFromJson st $ \val -> case J.toString val of
            Just "YES" -> Right $ Checkbox $ state { value = true }
            Just "NO" -> Right $ Checkbox $ state { value = false }
            _ -> Left $ StringError $ "Invalid checkbox value: " <> J.stringify val
        setBool = setFromJson st $ \val -> case J.toBoolean val of
            Just value -> Right $ Checkbox $ state { value = value }
            Nothing -> Left $ StringError $ "Invalid checkbox value: " <> J.stringify val
